import React, { Component} from 'react'
import { connect } from 'react-redux'
import { 
    Row, 
    Col, 
    Card, 
    Button, 
    Form } from 'react-bootstrap'
import Header from '../Header'
import Spinner from 'react-bootstrap/Spinner'
import { toast } from 'react-toastify';
import 'moment/locale/es';
import data, { key_local_storage_user, urlapi } from '../../lib/backend/data'
import { Link } from 'react-router-dom'
import 'moment/locale/es';
import Switch from "react-switch";
import { limpiarStringNumeros, validateEmail } from '../../lib/helpers/helpers'
import SinDatos from '../../subComponents/general/sin_registros'
import { acciones} from '../../lib/global/data'
import DescuentosListado from '../../subComponents/descuentos/list'
import ConfiguracionSelector from '../../subComponents/bodegas/selector'
import BodegasSelector from '../Bodega/selector_bodegas'

class UsuariosEditar extends Component {
    constructor(props){
        super(props)
        this.state = {
            user: JSON.parse(localStorage.getItem(key_local_storage_user)),
            id: this.props.match.params.id,
            usuario: false,
            loadingUsuario: false,
            comunas_descartar_creacion: [],
            show_password: false,
            guardandoCambios: false,
            cambiandoPassword: false,
            password: '',
            password_confirm: '',
            loadingPermisos: true,
            permisos: [],
            permisos_otorgados: []
        }
        this.handleChangeUsuario = this.handleChangeUsuario.bind(this)
        this.handleChangeChecked = this.handleChangeChecked.bind(this)
        this.handleChangeCheckedSpecialCode = this.handleChangeCheckedSpecialCode.bind(this)
        this.handleChangeCheckedPrice = this.handleChangeCheckedPrice.bind(this)
        this.handleChangePassword = this.handleChangePassword.bind(this)
        this.handleCheck = this.handleCheck.bind(this)
        this.handleChangeBodegaInterna = this.handleChangeBodegaInterna.bind(this)
    }

    handleChangePassword(e){
        const { name, value } = e.target
        return this.setState({ [name]: value })
    }

    handleCheck(e){
        const { permisos_otorgados } = this.state
        const { name } = e.target
        const permiso = e.target.getAttribute('permiso')
        // check if permissions are granted
        const i = permisos_otorgados.findIndex(per => per.slug === permiso)
        if(i > -1){

            if(e.target.checked === true){
                if(!permisos_otorgados[i].actions.includes(name)) permisos_otorgados[i].actions.push(name)
            } else {
                const pos = permisos_otorgados[i].actions.findIndex(action => action === name)
                if(pos > -1) permisos_otorgados[i].actions.splice(pos,1)
            }

        } else {
            permisos_otorgados.push({
                slug: permiso,
                actions: [ name ]
            })
        }
        return this.setState({ permisos_otorgados })
    }

    handleChangeUsuario(e){
        const { usuario } = this.state
        const { name, value } = e.target
        if(name === "phone"){
            usuario[name] = limpiarStringNumeros(value)
        } else {
            usuario[name] = value
        }
        return this.setState({ usuario })
    }

    handleChangeSucursal(value){
        const { usuario } = this.state
        usuario.sucursalId = value
        console.log({ value, usuario})
        return this.setState({ usuario })
    }
    
    handleChangeBodega(value){
        const { usuario } = this.state
        usuario.warehouseId = value
        console.log({ value, usuario})
        return this.setState({ usuario })
    }
    
    handleChangeBodegaInterna(value){
        const { usuario } = this.state
        usuario.id_bodega_origen_facturacion = value
        console.log({ value, usuario})
        return this.setState({ usuario })
    }

    handleChangeEspecial(value, name){
        const { usuario } = this.state
        usuario[name] = value
        console.log({ value, usuario})
        return this.setState({ usuario })
    }

    handleChangeCheckedEmision(checked, name){
        const { usuario } = this.state
        usuario[name] = checked
        console.log(usuario)
        return this.setState({ usuario })
    }

    handleChangeCheckedSpecialCode(checked){
        const { usuario } = this.state
        usuario.allow_special_code = checked
        return this.setState({ usuario })
    }

    handleChangeChecked(checked){
        const { usuario } = this.state
        usuario.allow_invoice_witouth_payment = checked
        return this.setState({ usuario })
    }
    
    handleChangeCheckedPrice(checked){
        const { usuario } = this.state
        usuario.allow_change_price_product = checked
        return this.setState({ usuario })
    }

    componentDidMount(){
        const { id } = this.state
        if(!id) return this.setState({ loadingUsuario: true })
        this.getUsuario(id)
        this.getEsquemaPermisos()
    }

    async getEsquemaPermisos(){
        const { user } = this.state
        let loading = 'loadingPermisos'
        this.setState({ [loading]: true })
        return fetch(`${data.urlapi}/permisos/modelo`,{
            method:'GET',
            headers: {
                'Content-Type':'application/json',
                'Authorization': `Bearer: ${user.tokenSession}`
            }
        })
        .then(res => {
            if(res.status === 401) return window.location = '/login'
            return res.json()
        })
        .then(res => {
            if(!res){
                toast.error('Sin datos')
                return this.setState({ [loading]: false })
            } else if(res.errorMessage){
                toast.error(res.errorMessage)
                return this.setState({ [loading]: false })
            }
            return this.setState({ permisos: res, [loading]: false })
        })
        .catch(error => {
            this.setState({ [loading]: false })
            toast.error("Error al consultar la información, intente nuevamente", this.state.toaststyle)
        })
    }

    async getUsuario(id){
        const { user } = this.state
        let loading = 'loadingUsuario'
        this.setState({ [loading]: true })
        return fetch(`${data.urlapi}/usuarios/details?id=${id}`,{
            method:'GET',
            headers: {
                'Content-Type':'application/json',
                'Authorization': `Bearer: ${user.tokenSession}`
            }
        })
        .then(res => {
            if(res.status === 401) return window.location = '/login'
            return res.json()
        })
        .then(res => {
            if(!res){
                toast.error('Sin datos')
                return this.setState({ [loading]: false })
            } else if(res.errorMessage){
                toast.error(res.errorMessage)
                return this.setState({ [loading]: false })
            }
            if(res.permisos){
                if(Array.isArray(res.permisos) !== false){
                    this.setState({ permisos_otorgados: res.permisos.map(p => ({ slug: p.module, actions: p.actions })) })
                }
            }
            return this.setState({ usuario: res, [loading]: false })
        })
        .catch(error => {
            this.setState({ [loading]: false })
            toast.error("Error al consultar la información, intente nuevamente", this.state.toaststyle)
        })
    }

    cambiarPassword(){
        const { usuario, user, password, password_confirm } = this.state
        if(!password_confirm || !password) return toast.error('Contraseña es requerida')
        if(password.length < 5) return toast.error('La contraseña debe tener al menos 5 carácteres')
        if(password !== password_confirm) return toast.error('Las contraseñas no coinciden')
        const loading = 'cambiandoPassword'
        this.setState({ [loading]: true })
        return fetch(`${data.urlapi}/usuarios/reset-password`,{
            method:'PUT',
            body: JSON.stringify( {
                id: usuario._id,
                password, 
                password_confirm
            } ),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer: ${user.tokenSession}`
            }
        })
        .then(res => {
            if(res.status === 401) return window.location = '/login'
            return res.json()
        })
        .then(res => {
            if(res._id){ 
                toast.success('Guardado exitosamente')
                setTimeout(() => {
                    window.location.reload()
                }, 1500);
            } else {
                toast.error('Ocurrió un error inesperado')
            }
            this.setState({ [loading]: false })
        })
        .catch(error => {
            this.setState({ [loading]: false })
            toast.error("Error al realizar esta operación, intente nuevamente", this.state.toaststyle)
        })
    }

    guardarCambios(){
        const { usuario, user, permisos_otorgados, permisos } = this.state
        const requeridos = [
            { value:'nombres', label: 'Nombres' },
            { value:'apellidos', label: 'Apellidos' },
            { value:'email', label: 'Email' },
            { value:'role', label: 'Rol de usuario' },
        ]
        let faltantes = []
        requeridos.map(campo => {
            if(!usuario[campo.value]) faltantes.push(campo.label)
            return true
        })
        if(faltantes.length > 0) return toast.error(`Faltan campos: ${faltantes.join(', ')}`)
        if(validateEmail(usuario.email) !== true) return toast.error('Email inválido')
        const loading = 'guardandoCambios'
        if(usuario.role === "admin"){
            // ACTIVAMOS TODOS LOS PERMISOS
            const todos = permisos.map(p => ({ slug: p.slug, actions: acciones.map(a => a.slug) }))
            console.log({todos})
            usuario.permisos = todos
        } else {
            usuario.permisos = permisos_otorgados
        }
        this.setState({ [loading]: true })
        return fetch(`${data.urlapi}/usuarios`,{
            method:'PUT',
            body: JSON.stringify( usuario ),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer: ${user.tokenSession}`
            }
        })
        .then(res => {
            if(res.status === 401) return window.location = '/login'
            return res.json()
        })
        .then(res => {
            console.log(res)
            if(res._id){ 
                toast.success('Guardado exitosamente')
                setTimeout(() => {
                    window.location.reload()
                }, 1500);
            } else {
                toast.error('Ocurrió un error inesperado')
            }
            this.setState({ [loading]: false })
        })
        .catch(error => {
            this.setState({ [loading]: false })
            toast.error("Error al realizar esta operación, intente nuevamente", this.state.toaststyle)
        })
    }

    permisos(){
        const { loadingPermisos, permisos_otorgados, permisos } = this.state
        if(loadingPermisos===true) return <Col xs={12} className="mt-3">
           <Spinner animation='border' />
           <h4>Cargando permisos</h4>
        </Col>
        return <Col xs={12}>
        <hr />
        <i className="fa-solid fa-sliders"></i>
        <h3>Permisos</h3>
        <Row>
        {
            permisos.map(permiso => {
                return <Col key={permiso._id} md={3} className="mb-4">
                    <h5>{permiso.titulo}</h5>
                    {
                        acciones.map((accion,i) => {
                            let checkeado = false
                            const pos = permisos_otorgados.findIndex(per => per.slug === permiso.slug)
                            if(pos > -1){
                                if(permisos_otorgados[pos].actions.includes(accion.slug)) checkeado = true
                            }
                            return <Form.Group key={accion.slug} className="mb-3" controlId={`${permiso._id}-${accion.slug}`}>
                                    <Form.Check type="switch" defaultChecked={checkeado} permiso={permiso.slug} name={accion.slug} label={accion.label} onChange={this.handleCheck} />
                                </Form.Group>
                        })
                    }
                    </Col>
            })
        }
        </Row>
        </Col>
    }

    descuentos() {
        const { user, usuario } = this.state
        return <div>
            <DescuentosListado condicion_default={{ id_usuario_autorizado: user._id }} token={user.tokenSession} usuario={user.data} target={usuario} />
        </div>
    }

    formularioUsuario(){
        const { loadingUsuario, show_password, cambiandoPassword, guardandoCambios, usuario } = this.state
        if(loadingUsuario) return <Spinner animation='border' />
        if(!usuario) return <SinDatos />
        return <div>
            <Row>
                <Col md={9}>
                <i className="icono fa-solid fa-gear"></i>
                <h3>Datos generales</h3>
                    <Row>
                    <Col md={3} className="mb-3">
                        <label className='form-control-label'>Nombres</label>
                        <input name="nombres" defaultValue={usuario.nombres} className='form-control' onChange={this.handleChangeUsuario} />
                    </Col>
                    <Col md={3} className="mb-3">
                        <label className='form-control-label'>Apellidos</label>
                        <input name="apellidos" defaultValue={usuario.apellidos} className='form-control' onChange={this.handleChangeUsuario} />
                    </Col>
                    <Col md={3} className="mb-3">
                        <label className='form-control-label'>Email</label>
                        <input name="email" defaultValue={usuario.email} className='form-control' onChange={this.handleChangeUsuario} />
                    </Col>
                    <Col md={3} className="mb-3">
                        <label className='form-control-label'>ID Fiscal</label>
                        <input name="rut" defaultValue={usuario.rut} className='form-control' onChange={this.handleChangeUsuario} />
                    </Col>
                    <Col md={3} className="mb-3">
                        <label className='form-control-label'>Fecha nacimiento</label>
                        <input name="fecha_nacimiento" defaultValue={usuario.fecha_nacimiento} type="date" className='form-control' onChange={this.handleChangeUsuario} />
                    </Col>
                    <Col md={3} className="mb-3">
                        <label className='form-control-label'>Teléfono</label>
                        <input name="phone" value={usuario.phone} className='form-control' onChange={this.handleChangeUsuario} />
                    </Col>
                    <Col md={3} className='mb-3'>
                        <ConfiguracionSelector url_refresh={`${urlapi}/configuracion/sincronizar-sucursales`} tipo="sucursal" subtipo="selector"  default_value={usuario.sucursalId} onChange={(e) => this.handleChangeSucursal(e)} titulo="Sucursal en facturación" />
                    </Col>
                    <Col md={3} className='mb-3'>
                        <ConfiguracionSelector url_refresh={`${urlapi}/configuracion/sincronizar-sucursales`} tipo="bodega" subtipo="selector"  default_value={usuario.warehouseId} onChange={(e) => this.handleChangeBodega(e)} titulo="Bodega en facturación" />
                    </Col>
                    <Col md={3} className='mb-3'>
                        <BodegasSelector helpText="Esta bodega es utilizada para restar inventario de manera interna en el sistema" default_value={usuario.id_bodega_origen_facturacion} titulo="Bodega origen de inventario" onChange={(e) => this.handleChangeBodegaInterna(e)} />
                    </Col>
                    <Col md={3} className='mb-3'>
                        <ConfiguracionSelector url_refresh={`${urlapi}/configuracion/sincronizar-vendedores`} tipo="vendedor" subtipo="selector"  default_value={usuario.salesmanId} onChange={(e) => this.handleChangeEspecial(e,'salesmanId')} titulo="Vendedor" />
                    </Col>
                    <Col md={3} className='mb-3'>
                        <ConfiguracionSelector url_refresh={`${urlapi}/configuracion/sincronizar-cajas`} tipo="cajas" subtipo="selector"  default_value={usuario.posId} onChange={(e) => this.handleChangeEspecial(e,'posId')} titulo="Caja" />
                    </Col>
                    <Col md={3} className="mb-3">
                        <label className='form-control-label'>Sexo</label>
                        <select name="sexo" defaultValue={usuario.sexo} className='form-control' onChange={this.handleChangeUsuario}>
                            <option value="">Selecciona</option>
                            <option value="H">Hombre</option>
                            <option value="M">Mujer</option>
                        </select>
                    </Col>
                    <Col md={3} className="mb-3">
                        <label className='form-control-label'>Estado</label>
                        <select name="status" defaultValue={usuario.status} className='form-control' onChange={this.handleChangeUsuario}>
                            <option value="">Selecciona</option>
                            <option value="active">Activo</option>
                            <option value="inactive">Inactivo</option>
                        </select>
                    </Col>
                    <Col md={3} className="mb-3">
                        <label className='form-control-label'>Rol de usuario</label>
                        <select name="role" defaultValue={usuario.role} className='form-control' onChange={this.handleChangeUsuario}>
                            <option value="">Selecciona</option>
                            <option value="user">Usuario</option>
                            <option value="admin">Administrador</option>
                        </select>
                    </Col>
                    
                    <Col md={3} className="mb-3">
                        <label className='form-control-label'>Aumento máximo de precio (Porcentaje)</label>
                        <input name="allow_rise_price_percentage" type="number" defaultValue={usuario.allow_rise_price_percentage} className='form-control' onChange={this.handleChangeUsuario} />
                    </Col>
                    <Col md={3} className="mb-3">
                        <label className='form-control-label'>Descuento máximo de precio (Porcentaje)</label>
                        <input name="allow_down_price_percentage" type="number" defaultValue={usuario.allow_down_price_percentage} className='form-control' onChange={this.handleChangeUsuario} />
                    </Col>
                    <Col xs={12}></Col>
                    <Col md={3} className="mb-3">
                        <label className='form-control-label d-block'>Permitir acceso al código fábrica</label>
                        <Switch onChange={this.handleChangeCheckedSpecialCode} checked={usuario.allow_special_code} />
                    </Col>
                    <Col md={3} className="mb-3">
                        <label className='form-control-label d-block'>Emite boleta electrónica</label>
                        <Switch onChange={(e) => this.handleChangeCheckedEmision(e, 'allow_emit_boleta')} checked={usuario.allow_emit_boleta} />
                    </Col>

                    <Col md={3} className="mb-3">
                        <label className='form-control-label d-block'>Emite factura electrónica</label>
                        <Switch onChange={(e) => this.handleChangeCheckedEmision(e, 'allow_emit_factura')} checked={usuario.allow_emit_factura} />
                    </Col>

                    <Col md={3} className="mb-3">
                        <label className='form-control-label d-block'>Permite modificar bodega</label>
                        <Switch onChange={(e) => this.handleChangeCheckedEmision(e, 'allow_change_warehouse')} checked={usuario.allow_change_warehouse} />
                    </Col>
                    <Col md={3} className="mb-3">
                        <label className='form-control-label d-block'>Emite guia despacho</label>
                        <Switch onChange={(e) => this.handleChangeCheckedEmision(e, 'allow_emit_guia_despacho')} checked={usuario.allow_emit_guia_despacho} />
                    </Col>
                    <Col md={3} className="mb-3">
                        <label className='form-control-label d-block'>Emite pedido picking</label>
                        <Switch onChange={(e) => this.handleChangeCheckedEmision(e, 'allow_emit_guia_pedido')} checked={usuario.allow_emit_guia_pedido} />
                    </Col>
                    <Col md={3} className="mb-3">
                        <label className='form-control-label d-block'>Emite Cotización</label>
                        <Switch onChange={(e) => this.handleChangeCheckedEmision(e, 'allow_emit_cotizacion')} checked={usuario.allow_emit_cotizacion} />
                    </Col>

                    <Col md={3} className="mb-3">
                        <label className='form-control-label d-block'>Permite modificar vendedor</label>
                        <Switch onChange={(e) => this.handleChangeCheckedEmision(e, 'allow_change_salesman')} checked={usuario.allow_change_salesman} />
                    </Col>

                    <Col md={3} className="mb-3">
                        <label className='form-control-label d-block'>Permitir facturar sin pagos</label>
                        <Switch onChange={this.handleChangeChecked} checked={usuario.allow_invoice_witouth_payment} />
                    </Col>
                    <Col md={3} className="mb-3">
                        <label className='form-control-label d-block'>Permitir cambiar precio al facturar</label>
                        <Switch onChange={this.handleChangeCheckedPrice} checked={usuario.allow_change_price_product} />
                    </Col>
                    <Col md={3} className="mb-3">
                        <label className='form-control-label d-block'>Desactivar caja</label>
                        <Switch onChange={this.handleChangeCheckedCaja} checked={usuario.unable_post_field} />
                    </Col>
                    </Row>
                </Col>
                <Col md={3}>
                    <i className="icono fa-solid fa-lock"></i>
                    <h3> Seguridad</h3>

                    <label className='form-control-label d-block'>Contraseña</label>
                    <input className='form-control mb-4' type={ show_password === true ? 'text' : 'password' } name="password" onChange={this.handleChangePassword} />

                    <label className='form-control-label d-block'>Repite Contraseña</label>
                    <input className='form-control mb-4' type={ show_password === true ? 'text' : 'password' } name="password_confirm" onChange={this.handleChangePassword} />

                    { cambiandoPassword === true ? <Spinner animation='border' /> : <Button variant="outline-primary" size="sm" onClick={()=>this.cambiarPassword()}>CAMBIAR CONTRASEÑA</Button>}
                </Col>
                <Col md={12}>
                    {this.descuentos()}
                </Col>
                {this.permisos()}
            </Row>
            <hr />
                        {
                            guardandoCambios === true ? <Spinner animation='border' /> : <Button size="sm" variant='success' onClick={()=>this.guardarCambios()}>GUARDAR CAMBIOS</Button>
                        }
        </div>
    }

    botonSeleccionar(id){
        const { planes_activos } = this.state
        const i = planes_activos.findIndex(plan => plan._id === id)
        if(i > -1) return <Button size="sm" variant="outline-secondary" >PLAN ACTIVO</Button>

        return <Button size="sm" variant="outline-primary" ><Link to={`pay-plan-${id}`} >SELECCIONAR</Link></Button>
    }
    
    render(){
        return(
            <div className="fluid">
       <Header/>
       <div className="container-fluid">
  <div className="row">
    <main className="col-md-12 ms-sm-auto col-lg-12 px-md-4 leftauto">
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center border-top pt-3 pb-2 mb-3 border-bottom">
      <Link to={`/usuarios`} className='text-dark' ><i className="fas fa-chevron-left"></i> Volver</Link>
      </div>
    <h1 className="h2">Editar usuario </h1>
      <Card >
          <Card.Body>
          {this.formularioUsuario()}
          </Card.Body>
      </Card>
    </main>
  </div>
</div>
    </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        miusuario: state.miusuario
    }
}

export default connect(mapStateToProps)(UsuariosEditar);